module.exports = __webpack_public_path__ + "img/sort／web／Racing@2x.156b2fd0.png";